import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import DesignationPolarArea from "../../Components/ParkDesignations/DesignationPolarArea";
import CampgroundsChart from "../../Components/Campgrounds/CampgroundsChart";
import "./genericPage.css";
import StateVsParks from "../../Components/BarChartStateVsNationalPark/StateVsParks";
import AlertsVsParks from "../../Components/Alerts3dPieChart/AlertsVsAllPark";
const GenericChart = () => {
  return (
    <div style={{ marginTop: "6rem" }}>
      <h1 className="text-center my-5 vis-title">
        Visualizations of all parks
      </h1>
      <Container className="barchart" style={{ marginBottom: "5rem" }}>
        <Row>
          <h2 style={{ fontSize: "24px" }} className="text-center">
            Bar Chart: State Vs Park Counts
          </h2>
          <StateVsParks />
        </Row>
      </Container>
      <Container>
        <Row>
          <Col>
            <h2 style={{ fontSize: "24px" }} className="text-center">
              Polar Area Chart: Park Designations
            </h2>
            <DesignationPolarArea className="py-5 designations" />
          </Col>
          <Col>
            <h2 style={{ fontSize: "24px" }} className="text-center">
              Pie Chart: Campgrounds
            </h2>
            <CampgroundsChart className="py-5 campgrounds" />
          </Col>
        </Row>
      </Container>
      <Container style={{ marginBottom: "5rem", marginTop: "18rem"}}>
        <Col>
          <h2 style={{ fontSize: "24px", marrginTop:"-70px" }} className="text-center">
            3D Pie Chart: Alerts counts per category
          </h2>
          <AlertsVsParks />
        </Col>
      </Container>
    </div>
  );
};

export default GenericChart;
